import React from 'react';
import SpinnerRender, {SpinnerProps} from './SpinnerRender';

export const Spinner=({...props}:SpinnerProps):JSX.Element=>{
	return <SpinnerRender {...props}/>;
};
